<ng-container [ngTemplateOutlet]="badge" />
@if (size() === 'dot' || size() === 'dot-large') {
  <ng-container [ngTemplateOutlet]="attachedBadge" />
} @else {
  <ng-container [ngTemplateOutlet]="standAloneBadge" />
}

<ng-template #badge><ng-content /></ng-template>
<ng-template #attachedBadge>
   <span class="td-wb-badge-item"
         [class.td-wb-badge-item--dot]="size() === 'dot'"
         [class.td-wb-badge-item--dot-large]="size() === 'dot-large'"></span>
</ng-template>
<ng-template #standAloneBadge>
  @if (showIndicator()) {
    <span class="td-wb-badge-indicator" ></span>
  }
  <span class="td-wb-badge-item"
        [class.td-wb-badge-item--large]="size() === 'large'"
        [class.td-wb-badge-item--extra-small]="size() === 'extra-small'"
        [textContent]="getBadgeText()"></span>
</ng-template>
